import { rfqRequestQuotePageContainerStyles } from "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuotePageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

rfqRequestQuotePageContainerStyles.container = {
    css: css`
        /* stylelint-disable value-no-vendor-prefix */
        display: -ms-grid;
        display: grid;
        padding: 0;
        margin: 0 auto;
        overflow: hidden;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        grid-template-columns: minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 1fr);
                    `,
                    null,
                    css`
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        -ms-grid-columns: minmax(0, 1fr) minmax(0, 1fr);
                        grid-template-rows: repeat(5, auto);
                        -ms-grid-rows: auto auto auto auto auto;
                    `,
                    css`
                        grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 2fr) minmax(0, 1fr);
                    `,
                ],
                "min",
            )}
    `,
};
rfqRequestQuotePageContainerStyles.cartLinesContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        border: 0 solid transparent;
                        border-width: 0 0 1.5rem 0;
                    `,
                    null,
                    css`
                        grid-column-start: 1;
                        -ms-grid-column: 1;
                        grid-row-start: 1;
                        -ms-grid-row: 1;
                        grid-row-end: 6;
                        -ms-grid-row-span: 6;
                    `,
                    css`
                        border: 0 solid transparent;
                        border-width: 0 1.5rem 1.5rem 0;
                    `,
                ],
                "min",
            )}
    `,
};
rfqRequestQuotePageContainerStyles.specificationsContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        border: 0 solid transparent;
                        border-width: 0 0 1.5rem 0;
                    `,
                    null,
                    css`
                        grid-column-start: 2;
                        -ms-grid-column: 2;
                        grid-row-start: 1;
                        -ms-grid-row: 1;
                    `,
                ],
                "min",
            )}
    `,
};
